import type { DsdEditorCorrectionItem } from "@/utils/dsd-editor/spellcheck";
import { DsdReviewCorrectionList } from "./correction-list";
import { DsdReviewBackButton } from "../panel/back-button";
import { DsdReviewGuideCard } from "../guide-card";

/** 맞춤법 교정 패널 — 목록·상세(correction-list) 위에 머리를 안내 카드로 얹는다 */
export const DsdReviewCorrectionPanel = ({
  count,
  items,
  activeItemId,
  onSelect,
  onClear,
  onPrevious,
  onNext,
}: {
  count: number;
  items: DsdEditorCorrectionItem[];
  activeItemId: string | null;
  onSelect: (item: DsdEditorCorrectionItem) => void;
  onClear: () => void;
  onPrevious: () => void;
  onNext: () => void;
}) => (
  <DsdReviewCorrectionList
    items={items}
    activeItemId={activeItemId}
    onSelect={onSelect}
    onPrevious={onPrevious}
    onNext={onNext}
    header={(isDetail) => (
      <>
        <div className="shrink-0 p-4">
          <DsdReviewGuideCard
            mode="corrections"
            count={count}
            variant="embedded"
            collapsed={isDetail}
          />
        </div>
        {isDetail && <DsdReviewBackButton onBack={onClear} />}
      </>
    )}
  />
);
